import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { AlertNotice, ModalInfo } from 'shared/components';
import { sumBy } from 'lodash';
import { isRoomOnline } from 'shared/helpers';
import './MaterialChainSubmit.scss';

const MaterialChainSubmit = (props) => {
  const { t } = useTranslation();
  return (
    <ModalInfo
      modalIsOpen={props.submitModalOpen}
      closeModal={() => props.toggleSubmitRanges()}
      onSubmit={props.onSubmitRanges}
      className={`submit-ranges-modal ${isRoomOnline(props.room.roomType) ? 'online-submit' : ''}`}
      headerTitle={isRoomOnline(props.room.roomType) ? '' : t('materialChain.submitRangesHeader')}
      saveLabel={t('common.labels.submit')}
      showCancel
      cancelLabel={t('common.labels.back')}>
      <div>
        <h4>
          {t(
            isRoomOnline(props.room.roomType)
              ? 'materialChain.submitOnlineTitle'
              : 'materialChain.submitRangesTitle'
          )}
        </h4>
        <h4>{props.room.name}</h4>
        <div>
          {props.roomMaterials[props.room.id] && props.roomMaterials[props.room.id].length && (
            <div className="submit-range-section">
              {props.tcEventMaterialTypes.map((materialType) =>
                props.roomMaterials[props.room.id][materialType.id] ? (
                  <div key={`type-${materialType.id}`}>
                    <p className="mb-2 fw-bold">
                      {materialType.name}
                      <span>
                        ({sumBy(props.roomMaterials[props.room.id][materialType.id], 'count')})
                      </span>
                    </p>
                    {props.roomMaterials[props.room.id][materialType.id].length &&
                      props.roomMaterials[props.room.id][materialType.id].map((material) => (
                        <div key={`material-${material.id}`}>
                          <div>{`${material.rangeBegin} - ${material.rangeEnd} (${material.count})`}</div>
                          <p>
                            <span>
                              {t('roomDashboard.materialChain.usedLabel')}: {material.usedCount}{' '}
                            </span>{' '}
                            |
                            <span>
                              {t('roomDashboard.materialChain.unusedLabel')}: {material.unusedCount}{' '}
                            </span>
                          </p>
                        </div>
                      ))}
                  </div>
                ) : null
              )}
            </div>
          )}

          {!isRoomOnline(props.room.roomType) && (
            <div className="submit-range-section">
              <p className="mb-2 fw-bold">{t('roomDashboard.materialChain.answerDocuments')}</p>
              <div>
                <span>
                  {t('roomDashboard.materialChain.toBeScoredLabel')}: {props.room.answerDocScored}{' '}
                </span>{' '}
                |
                <span>
                  {t('roomDashboard.materialChain.voidedLabel')}: {props.room.answerDocVoided}{' '}
                </span>{' '}
                |
                <span>
                  {t('roomDashboard.materialChain.replacedLabel')}: {props.room.answerDocReplaced}{' '}
                </span>
              </div>
            </div>
          )}

          <div className="submit-range-section">
            <p className="mb-2 fw-bold">
              {t(
                isRoomOnline(props.room.roomType)
                  ? 'roomDashboard.materialChain.examineeNumberOnlineLabel'
                  : 'roomDashboard.materialChain.examineeNumberLabel'
              )}
            </p>
            <p>{props.room.examineeCount}</p>
          </div>
        </div>
        {!isEmpty(props.errorSubmitRanges) && (
          <AlertNotice message={t('errors.somethingWentWrong')} type="error" />
        )}
      </div>
    </ModalInfo>
  );
};

MaterialChainSubmit.propTypes = {
  roomMaterials: PropTypes.shape({}),
  room: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    roomType: PropTypes.shape({
      onlineFlag: PropTypes.bool,
    }),
    examineeCount: PropTypes.number,
    answerDocScored: PropTypes.number,
    answerDocVoided: PropTypes.number,
    answerDocReplaced: PropTypes.number,
  }).isRequired,
  tcEventMaterialTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  submitModalOpen: PropTypes.bool,
  toggleSubmitRanges: PropTypes.func,
  onSubmitRanges: PropTypes.func,
  errorSubmitRanges: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default MaterialChainSubmit;
